import { render } from "./App.vue?vue&type=template&id=9bd71938"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=9bd71938&lang=scss"

import exportComponent from "/home/runner/work/eoy-2022-frontend/eoy-2022-frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__